import {Controller} from "@hotwired/stimulus"

/**
 * Adds/remove a class from its targets.
 *
 * This is mostly useful to hide/show things but lets you use whatever class you like
 * (based on data-toggle-class).
 *
 * You can call reapply if the targets change,
 * and we'll add/remove the class based on the current state.
 *
 * We assume the DOM starts with the class.
 * (We could parameterize that though, and maybe also enforce it in connect().)
 */
export default class extends Controller {
    static targets = ["toggleable", "spanning"];

    connect() {
        // Remember which state we're in
        // so that if targets get added later, we can set them correctly.
        console.log("Toggle controller connected");
        this.hasClass = true;
        this.applySpans();
    }

    toggle(ev) {
        ev.preventDefault();
        this.hasClass = !this.hasClass;
        this.toggleableTargets.forEach(t => t.classList.toggle(this.data.get("class")));
        this.applySpans();
    }

    // If a product search happens,
    // we need to set the results to the same hide/show as the other rows.
    reapply(ev) {
        if (this.hasClass) {
            this.toggleableTargets.forEach(t => t.classList.add(this.data.get("class")));
        } else {
            this.toggleableTargets.forEach(t => t.classList.remove(this.data.get("class")));
        }
        this.applySpans();
    }

    //
        // A full-width cell has to grow with the columns the toggle reveals, or the row
        // is longer than the rest and the table sprouts a column nothing fills.
    applySpans() {
        const columns = parseInt(this.data.get("columns") || "0", 10);
        if (!columns || !this.hasSpanningTarget) return;

        this.spanningTargets.forEach(cell => {
            const base = parseInt(cell.dataset.toggleSpanBase || cell.colSpan, 10);
            cell.colSpan = this.hasClass ? base : base + columns;
        });
    }
}
